/* eslint-disable */
import React, { useEffect, useState } from "react";
import * as API from "../../../framework/API/api";
import { ENTITYNAME, LOGEVENT, MODULE, OFFER_TYPE, PREFERENCE_ENTITYNAME, TOAST_TYPES } from "../../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { utility } from "../../../framework/utility/utilityProvider";
import { useTranslation } from "../../../locale/useTranslation";
import { EditPageHeader } from "../../../components/EditPageHeader";
import BossDialog from "../../../components/BossDialog";
import { PriceCodeEditForm } from "../../masters/PriceCodeEditForm";
import moment from "moment";
import CollectionSelection from "../../../framework/forms/CollectionSelection";
import ToastNotification from "../../../components/ToastNotification";

const CreateTransmissionOfferForm = (props) => {

    const { cancelEdit, item = {}, isFromTransmission = false, transmissionIds = [], refreshData, node = {} } = props;

    const lang = useTranslation();
    const isMultiTransmission = transmissionIds?.length > 1;

    const blankDataItem = {
        ...item,
        Title: item?.Title ?? '',
        DisplayTitle: item?.DisplayTitle ?? "",
        Description: item?.Description ?? "",
        TranslatedDescription: item?.TranslatedDescription ?? "",
        TranslatedDisplayTitle: item?.TranslatedDisplayTitle ?? "",
        StartDateTime: item?.StartDateTime
            ? moment.utc(item.StartDateTime).startOf("day").toISOString()
            : moment.utc().add(1, "days").startOf("day").toISOString(),
        EndDateTime: item?.EndDateTime
            ? moment.utc(item.EndDateTime).startOf("day").toISOString()
            : moment.utc([2050, 11, 31]).startOf("day").toISOString(),
        PriceCode: item?.PriceCode ? item?.PriceCode : {},
        OfferType: isFromTransmission ? { _id: OFFER_TYPE.single, Description: utility.getKeyByValue(OFFER_TYPE, OFFER_TYPE.single) } : item?.OfferType ? { _id: item?.OfferType, Description: utility.getKeyByValue(OFFER_TYPE, item?.OfferType) } : { _id: OFFER_TYPE.subscription, Description: utility.getKeyByValue(OFFER_TYPE, OFFER_TYPE.subscription) },
        IsPayPerTime: item?.IsPayPerTime ?? false,
        // ExternalReference: "",
        Archive: item?.Archive ?? false
    }

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [pricecode, setPriceCode] = useState([]);
    const [showCreatePriceCodeForm, setShowCreatePriceCodeForm] = useState(false);
    const [showFormFields, setShowFormFields] = useState({ show: false, field: "Title" });
    const [currency, setCurrency] = useState([]);

    useEffect(() => {
        loadCombo();
    }, []);

    useEffect(() => {
        loadTransmissionData();
    }, [transmissionIds]);

    const loadCombo = async () => {
        let priceCodeRes = await API.getDataLookup(ENTITYNAME.PRICECODE, { sort: { Description: 1 } });
        setPriceCode(priceCodeRes.data ?? []);
        let currencyRes = await API.getDataLookup(ENTITYNAME.Currency, { sort: { Description: 1 } });
        setCurrency(currencyRes.data ?? []);
    }

    const loadTransmissionData = async () => {
        if (isMultiTransmission) return;
        const transmissionId = transmissionIds?.length > 0 ? transmissionIds[0] : null;
        if (!transmissionId) return;
        let res = await API.getData(ENTITYNAME.Transmissions, { query: ["_id", "=", transmissionId] });

        if (res.success) {
            const transmissionData = res.data?.length > 0 ? res.data[0] : {};
            setDataItem({ ...dataItem, StartDateTime: moment(transmissionData?.startDate).utc().format("YYYY-MM-DD"), EndDateTime: moment(transmissionData?.endDate).utc().format("YYYY-MM-DD") });
        }
    }

    const onChange = (e) => {
        if (e.target.name == "Archive") {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        } if (e.target.name == "IsPayPerTime") {
            setDataItem({ ...dataItem, IsPayPerTime: !dataItem.IsPayPerTime });
        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    }

    const isValid = () => {

        if (dataItem.Title == undefined || dataItem.Title.trim().length == 0 || dataItem.Title == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_title_error_message });
            return false;
        }
        if (dataItem.DisplayTitle == undefined || dataItem.DisplayTitle.trim().length == 0 || dataItem.DisplayTitle == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_display_title_error_message });
            return false;
        }
        if (dataItem.Description == undefined || dataItem.Description.trim().length == 0 || dataItem.Description == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_description_error_message });
            return false;
        }
        if (dataItem.StartDateTime == undefined || dataItem.StartDateTime == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_start_date_time_error_message });
            return false;
        }

        if (dataItem.EndDateTime == undefined || dataItem.EndDateTime == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_end_date_time_error_message });
            return false;
        }

        return true;
    }

    const handleSubmit = async (e) => {

        if (!isValid()) return;

        const finalData = {
            _id: dataItem._id,
            SID: dataItem.SID,
            CSID: dataItem.CSID,
            Title: dataItem.Title,
            Description: dataItem.Description,
            TranslatedDescription: dataItem.TranslatedDescription,
            DisplayTitle: dataItem.DisplayTitle,
            TranslatedDisplayTitle: dataItem.TranslatedDisplayTitle,
            StartDateTime: dataItem.StartDateTime
                ? moment(dataItem.StartDateTime).utc().valueOf()
                : null,
            EndDateTime: dataItem.EndDateTime
                ? moment(dataItem.EndDateTime).utc().valueOf()
                : null,
            PriceCode: dataItem?.PriceCode && Object.keys(dataItem?.PriceCode).length > 0
                ? {
                    _id: dataItem?.PriceCode?._id,
                    SID: dataItem?.PriceCode?.SID,
                    CSID: dataItem?.PriceCode?.CSID,
                    Description: dataItem?.PriceCode?.Description,
                    Code: dataItem?.PriceCode?.Code,
                    Price: dataItem?.PriceCode?.Price,
                    Currency: dataItem?.PriceCode?.Currency?._id ? { _id: dataItem?.PriceCode?.Currency?._id, Description: dataItem?.PriceCode?.Currency?.Description } : {},
                    Days: dataItem?.PriceCode?.Days,
                    Duration: parseInt(dataItem?.PriceCode?.Duration ?? 0)
                }
                : {},
            OfferType: dataItem.OfferType?._id,
            IsPayPerTime: dataItem.OfferType?._id === OFFER_TYPE.subscription ? true : false,
            // ExternalReference: dataItem.ExternalReference ?? "",
            Archive: dataItem.Archive ?? false
        }

        let res = await API.createTransmissionOffer({ offerData: finalData, transmissionIds: transmissionIds, isFromTransmission: isFromTransmission ?? false, node: node });
        if (res.success) {
            let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.OFFER, data: res.data, message: res.message };
            API.SaveLogs(logData);
            utility.deleteLocalStorageItem(ENTITYNAME.OFFER);
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
            cancelEdit();
            refreshData && refreshData();
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    const style = {
        mainStyle: {
            padding: '5px 8px 0px 8px',
            marginBottom: '10px',
            dding: '12px 14px',
            background: '#fafafa',
            borderRadius: '6px',
            border: '1px solid #f0f0f0'
        },
        subStyle: {
            fontSize: '10px',
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '1px',
            color: '#3A3633',
            marginBottom: '10px',
            paddingLeft: '8px',
            borderLeft: '3px solid #3A3633'
        }
    }

    const handleFormFieldSelection = (data = []) => {
        console.log(data);
        if (data?.length == 0){
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_data_found_error_message });
            return;
        }
        const value = data?.[0] ?? {};
        setDataItem({ ...dataItem, [showFormFields.field]: `${dataItem[showFormFields.field] || ""}[${value.name}]` })
        setShowFormFields({ show: false, field: "" })
    }

    const onPriceCodeChange = (e) => {
        const name = e?.target?.props?.name ?? e?.target?.name;
        const value = e?.value ?? e?.target?.value;
        setDataItem((prev) => ({
            ...prev,
            PriceCode: {
                ...prev.PriceCode,
                [name]: value
            }
        }));
    };

    return (
        <BossDialog title={dataItem._id ? lang.edit_offer_dialog_title : lang.create_offer_dialog_title} onClose={cancelEdit} width={"770px"}>
            <EditPageHeader onSubmit={handleSubmit} onCancel={cancelEdit} showTitle={false} />
            <div className="mt-3" style={style.mainStyle}>
                <div style={style.subStyle}>
                    {lang.title_label} & {lang.offer_type_label} & {lang.external_reference_label}
                </div>
                <div className="row form-group">
                    <div className="col-6">
                        <label>{lang.title_label} *</label>
                        <div className="d-flex align-items-center gap-2">
                            <input
                                name="Title"
                                type="text"
                                className="form-control form-control-sm"
                                onChange={onChange}
                                value={dataItem.Title}
                            />
                            <button
                                type="button"
                                className="ml-2 k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                                title={lang.add_field_button_tooltip}
                                onClick={() => setShowFormFields({ show: true, field: "Title" })}
                                style={{ width: "34px", height: "30px" }}
                            >
                                <i className="fa fa-ellipsis-h" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                    <div className="col-6" >
                        <div className="d-flex justify-content-between align-items-center">
                            <label className="mb-0">{lang.offer_type_label}</label>
                            {dataItem.OfferType?._id === OFFER_TYPE.subscription && <span className="d-flex align-items-center">
                                <input
                                    type="checkbox"
                                    name="IsPayPerTime"
                                    checked={dataItem.IsPayPerTime}
                                    onChange={onChange}
                                    disabled
                                    className="mr-1 text-primary"
                                />
                                {lang.pay_per_time_label}
                            </span>}
                        </div>
                        <DropDownList
                            data={
                                Object.keys(OFFER_TYPE).map((obj) => {
                                    return {
                                        _id: OFFER_TYPE[obj],
                                        Description: obj
                                    }
                                })
                            }
                            name="OfferType"
                            textField="Description"
                            dataItemKey="_id"
                            value={dataItem.OfferType}
                            onChange={onChange}
                        />
                    </div>
                    {/* <div className="col-4">
                        <label>{lang.external_reference_label}</label>
                        <input
                            name={"ExternalReference"}
                            type="text"
                            className="form-control form-control-sm"
                            onChange={onChange}
                            value={dataItem.ExternalReference}
                        />
                    </div> */}
                </div>
            </div>
            <div style={style.mainStyle}>
                <div style={style.subStyle}>
                    {lang.display_title_label} & {lang.description_label}
                </div>
                <div className="row form-group">
                    <div className="col-6">
                        <label>{lang.display_title_label} *</label>
                        <div className="d-flex align-items-center gap-2">
                            <input
                                name="DisplayTitle"
                                type="text"
                                className="form-control form-control-sm"
                                onChange={onChange}
                                value={dataItem.DisplayTitle}
                            />
                            <button
                                type="button"
                                className="ml-2 k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                                title={lang.add_field_button_tooltip}
                                onClick={() => setShowFormFields({ show: true, field: "DisplayTitle" })}
                                style={{ width: "34px", height: "30px" }}
                            >
                                <i className="fa fa-ellipsis-h" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                    <div className="col-6">
                        <label>{lang.description_label} *</label>
                        <div className="d-flex align-items-center gap-2">
                            <input
                                name="Description"
                                type="text"
                                className="form-control form-control-sm"
                                onChange={onChange}
                                value={dataItem.Description}
                            />
                            <button
                                type="button"
                                className="ml-2 k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                                title={lang.add_field_button_tooltip}
                                onClick={() => setShowFormFields({ show: true, field: "Description" })}
                                style={{ width: "34px", height: "30px" }}
                            >
                                <i className="fa fa-ellipsis-h" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>

                </div>
            </div>
            <div style={style.mainStyle}>
                <div style={style.subStyle}>
                    {lang.translated_display_title_label} & {lang.translated_display_title_label}
                </div>
                <div className="row form-group">
                    <div className="col-6">
                        <label>{lang.translated_display_title_label}</label>
                        <div className="d-flex align-items-center gap-2">
                            <input
                                name={"TranslatedDisplayTitle"}
                                type="text"
                                className="form-control form-control-sm"
                                onChange={onChange}
                                value={dataItem.TranslatedDisplayTitle}
                            />
                            <button
                                type="button"
                                className="ml-2 k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                                title={lang.add_field_button_tooltip}
                                onClick={() => setShowFormFields({ show: true, field: "TranslatedDisplayTitle" })}
                                style={{ width: "34px", height: "30px" }}
                            >
                                <i className="fa fa-ellipsis-h" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                    <div className="col-6">
                        <label>{lang.translated_Description_label}</label>
                        <div className="d-flex align-items-center gap-2">
                            <input
                                name={"TranslatedDescription"}
                                type="text"
                                className="form-control form-control-sm"
                                onChange={onChange}
                                value={dataItem.TranslatedDescription}
                            />
                            <button
                                type="button"
                                className="ml-2 k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                                title={lang.add_field_button_tooltip}
                                onClick={() => setShowFormFields({ show: true, field: "TranslatedDescription" })}
                                style={{ width: "34px", height: "30px" }}
                            >
                                <i className="fa fa-ellipsis-h" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {
                !isMultiTransmission && <div style={style.mainStyle}>
                    <div style={style.subStyle}>
                        {lang.date_label}
                    </div>
                    <div className="row form-group">
                        <div className="col-6">
                            <label>{lang.start_date_lable} *</label>
                            <input
                                name="StartDateTime"
                                type="date"
                                className="form-control form-control-sm"
                                value={
                                    dataItem?.StartDateTime
                                        ? moment.utc(dataItem.StartDateTime).format("YYYY-MM-DD")
                                        : ""
                                }
                                onChange={onChange}
                            />
                        </div>
                        <div className="col-6">
                            <label>{lang.end_Date_label} *</label>
                            <input
                                name="EndDateTime"
                                type="date"
                                className="form-control form-control-sm"
                                value={
                                    dataItem?.EndDateTime
                                        ? moment.utc(dataItem.EndDateTime).format("YYYY-MM-DD")
                                        : ""
                                }
                                onChange={onChange}
                            />
                        </div>
                    </div>
                </div>
            }
            <div style={style.mainStyle}>
                <div style={style.subStyle}>
                    {lang.price_code_details_label}
                </div>

                <div className="row form-group">
                    <div className="col-5">
                        <label>{lang.price_code_label}</label>

                        <div className="position-relative price-hover-wrapper">
                            <DropDownList
                                data={pricecode}
                                name="PriceCode"
                                textField="Description"
                                dataItemKey="_id"
                                value={dataItem.PriceCode}
                                onChange={onChange}
                            />
                        </div>
                    </div>

                    <div
                        className="col-3 d-flex align-items-end"
                        style={{ marginTop: "20px" }}
                    >
                        {/* Create Button */}
                        <button
                            type="button"
                            title={lang.create_price_code_button_tooltip}
                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary me-2"
                            style={{ height: "30px" }}
                            onClick={() => {
                                setShowCreatePriceCodeForm(true);
                            }}
                        >
                            <i className="fa-solid fa-plus fa-xs"></i>
                        </button>

                        {/* Clear Button */}
                        <button
                            type="button"
                            title="Clear Price Code"
                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base ml-2"
                            style={{ height: "30px" }}
                            onClick={() => {
                                setDataItem({
                                    ...dataItem,
                                    PriceCode: {}
                                });
                            }}
                        >
                            <i className="fa-solid fa-xmark fa-xs"></i>
                        </button>
                    </div>
                </div>

                <div className="row form-group">
                    {dataItem.PriceCode?._id &&
                        Object.keys(dataItem.PriceCode).length > 0 &&
                        Object.entries(dataItem.PriceCode).map(([key, value]) => {

                            if (
                                [
                                    "_id",
                                    "SID",
                                    "CSID",
                                    "Archive",
                                    "IsDefault",
                                    "addOn",
                                    "addBy",
                                    "modOn",
                                    "modBy"
                                ].includes(key)
                            ) return null;

                            let displayValue = value;

                            if (typeof value === "object" && value !== null) {
                                displayValue = value?.Description || "";
                            }

                            // Label Changes
                            let labelName = key;

                            if (key === "Days") {
                                labelName = "Time Unit";
                            }

                            if (key === "Duration") {
                                labelName = "Rental Duration (Days)";
                            }

                            // Number Input Fields
                            const isNumberField = ["Price", "Days", "Duration"].includes(key);

                            return (
                                <div className="col-4" key={key}>
                                    <label>{labelName}</label>

                                    {/* Currency Dropdown */}
                                    {key === "Currency" ? (
                                        <DropDownList
                                            data={currency}
                                            name={key}
                                            textField="Description"
                                            dataItemKey="_id"
                                            value={dataItem.PriceCode?.Currency}
                                            onChange={onPriceCodeChange}
                                        />
                                    ) : (
                                        <input
                                            name={key}
                                            type={isNumberField ? "number" : "text"}
                                            className="form-control form-control-sm"
                                            value={displayValue || ""}
                                            onChange={onPriceCodeChange}
                                        />
                                    )}
                                </div>
                            );
                        })}
                </div>
            </div>
            <div style={style.mainStyle}>
                <div style={style.subStyle}>
                    {lang.archive}
                </div>
                <div className="col mt-4">
                    <input
                        type="checkbox"
                        name="Archive"
                        onChange={(e) => onChange(e)}
                        value={dataItem.Archive}
                        checked={dataItem.Archive}
                    />
                    <label className="ml-1">{lang.archive}</label>
                </div>
            </div>
            {showCreatePriceCodeForm && <PriceCodeEditForm item={{ SID: 0 }} cancelEdit={() => setShowCreatePriceCodeForm(false)} refresh={(priceCode) => { setDataItem({ ...dataItem, PriceCode: priceCode }) }} />}
            {showFormFields.show && <CollectionSelection shortBy="sequence" dataItemKey="_id" addButtonTitle={lang.select_button_text} title="Select Form Field" mode="single" setDataList={handleFormFieldSelection} wherestatement={["entityName", "=", PREFERENCE_ENTITYNAME.transmissionMediaEpisode]} closeForm={() => setShowFormFields({ show: false, field: "" })} entityname={ENTITYNAME.FormFields} width="50vw" />}
        </BossDialog >)
};

export default CreateTransmissionOfferForm;